import React, {FC} from "react";
import {isValidCIF, isValidCRMEntityID} from "../../company-list/list-filters";
import CONSTANTS from "../../../../utils/constants";
import {formatDate} from "../../../../utils/common-utils";

const TooltipContentByLayout: FC<any> = ({data, filterType, searchSetting}) => {
    const {
        codatCompanyId,
        name,
        crmEntityId,
        cif,
        monthlyRefresh,
        last_refresh_date,
        event_datetime,
        timeline_message,
        refreshed_by,
        ct_client_tags,
    } = data;

    const legalName = name || 'NA';
    if (filterType === CONSTANTS.DISCONNECTION_MANAGEMENT_FILTERS.ACTIONED || searchSetting === 'SEARCH_ALL_COMPANIES')
        return <div data-testid={`${codatCompanyId}-tooltip-preview`}>{legalName}</div>;


    const previewCrmEntityIdNCif = [];
    if (isValidCRMEntityID(crmEntityId)) previewCrmEntityIdNCif.push(`CRM Entity ID: ${crmEntityId}`);
    if (isValidCIF(cif)) previewCrmEntityIdNCif.push(`CIF: ${cif}`);

    const monthlyRefreshStatus = `${monthlyRefresh ? 'Enabled' : ' Disabled'}`;
    const lastRefreshDate = last_refresh_date ? formatDate(last_refresh_date, 'MMM DD YYYY') : null;
    const previewTimelineMessage = `${formatDate(event_datetime, "MMM DD YYYY hh:mm a")} PT, ${timeline_message}, By ${refreshed_by}`
    const tags = ct_client_tags ?? "";
    const previewCTTags = tags.length > 50 ? `${tags.slice(0, 50)}...` : tags;
    return <>
        <div data-testid={`${codatCompanyId}-tooltip-preview`}>
            {legalName}
            <br/>
            {previewCrmEntityIdNCif.join(', ')}
            <br/><br/>
            <ul style={{paddingLeft: "20px"}}>
                <li>Last Refresh Date: {lastRefreshDate}</li>
                <li>Monthly Refresh: {monthlyRefreshStatus}</li>
                <li>Last Timeline Entry: {previewTimelineMessage}</li>
                <li>CT Tags: {previewCTTags}</li>
            </ul>
        </div>
    </>
}

export default TooltipContentByLayout;